import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import * as Sentry from "@sentry/react";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import { ToastProvider } from "../src/components/common/ToastProvider";

import { BrowserRouter, MemoryRouter } from "react-router-dom";

Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENV || "production",
    sendDefaultPii: true,
    tracesSampleRate: process.env.NODE_ENV === "production" ? 0.2 : 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
        Sentry.browserTracingIntegration(),
    ],
});

const isEmbed = new URLSearchParams(window.location.search).get("embed") === "true";

const Router = isEmbed ? MemoryRouter : BrowserRouter;

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
    <React.StrictMode>
        <Router
            future={{
                v7_startTransition: true,
                v7_relativeSplatPath: true,
            }}
        >
            <Provider store={store}>
                <ThemeProvider theme={theme}>
                    <ToastProvider>
                        <App />
                    </ToastProvider>
                </ThemeProvider>
            </Provider>
        </Router>
    </React.StrictMode>,
);

reportWebVitals();
